//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
let d=[[],[[["type","filterClasses","properties","userAttributes"],"AddClassObserver",{},4,0],[["type"],"RemoveClassObserver",{},1,0],[["type"],"RefreshClass",{},1,0]],[]];
SPLM.AtlasObserver = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AtlasObserver";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AtlasObserver.ObserverType = Object.freeze({
    "Feature" : "Feature", "Component" : "Component", "Pmi" : "Pmi", "Body" : "Body", "Part" : "Part", "Session" : "Session", "ModelingView" : "ModelingView", "Facet" : "Facet", "CAMOperation" : "CAMOperation", "CAMTool" : "CAMTool", "CAMFeatureGeometryGroup" : "CAMFeatureGeometryGroup", "CAMFeatureGeometry" : "CAMFeatureGeometry", "CAMOrientGeometry" : "CAMOrientGeometry", "CAMProgram" : "CAMProgram", "CAMNCGroup" : "CAMNCGroup", "MBDNavContainer" : "MBDNavContainer", "Annotation" : "Annotation", "DrawingSheet" : "DrawingSheet", "DraftingView" : "DraftingView", "SectionLine" : "SectionLine"});

export default SPLM;